import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty';
import { IconName } from '@/utils/iconName';
import SvgIcon from './Icon/SvgIcon';

export function EmptyPage({
  title,
  description,
  icon,
  iconName,
  children,
}: {
  title: string;
  description?: string;
  icon?: React.ReactNode;
  iconName?: IconName;
  children?: React.ReactNode;
}) {
  return (
    <Empty>
      <EmptyHeader>
        {!!iconName && (
          <EmptyMedia variant="icon">
            <SvgIcon name={iconName} />
          </EmptyMedia>
        )}
        {!!icon && <EmptyMedia variant="icon">{icon}</EmptyMedia>}
        <EmptyTitle>{title}</EmptyTitle>
        {!!description && <EmptyDescription>{description}</EmptyDescription>}
      </EmptyHeader>
      {!!children && <EmptyContent>{children}</EmptyContent>}
    </Empty>
  );
}
